module.exports = __webpack_public_path__ + "img/icon-voltaware.0fe17c88.svg";